import { IconButton } from "@mui/material";
import { BsThreeDotsVertical, BsTicketPerforated } from "react-icons/bs";
import { getBookingId, openTaskRoute, StatusTag, timeAgo } from "../../utils/task/taskUtilFun";

function TaskCard({ task, index, handleOpenMenu }) {
  return (
    <div
      key={index}
      className="flex items-center justify-between px-6 py-6 border-b last:border-b-0 hover:bg-gray-50 transition"
    >
      <div className="flex items-start gap-4">
        <div className="mt-1 text-gray-500">
          <BsTicketPerforated size={18} />
        </div>

        <div>
          <div className="flex items-center gap-2">
            <span
              onClick={() => openTaskRoute("ViewRequest", task)}
              className="text-blue-600 text-sm font-medium hover:underline"
            >
              {getBookingId(task) || "---"}
            </span>
            <span className="text-sm text-gray-800 font-medium">
              {task.taskType}
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-1 max-w-3xl">{task.note}</p>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex flex-col space-y-2">
          <StatusTag status={task?.taskStatus} />
          <span className="text-sm text-gray-400 whitespace-nowrap">
            {timeAgo(task.updatedAt)}
          </span>
        </div>
        <IconButton size="small" onClick={(e) => handleOpenMenu(e, task)}>
          <BsThreeDotsVertical />
        </IconButton>
      </div>
    </div>
  );
}

export default TaskCard;
